//引入外部模組
import {checkDevice} from '@/common';
import {BodyCtrl} from '@/body_ctrl';
import {LazyLoad} from '@/lazyload';
import {Lightbox} from '@/lightbox.js';
import {Track} from '@/track';




//AJAX 物件列表 (頁碼載入)
class ObjListAJAX {
  constructor() {
    this.nav = $('#navVal').val();

    this.preloader = $('#preloader');
    this.logo      = this.preloader.find('.icon');

    this.header         = $('header');
    this.search         = $('#rwdSearch');
    this.lightbox       = $('#rwdLightbox');
    // this.searchForm     = this.search.find('#objectSearch');
    // this.searchForm     = this.search.find('#rwdSearchForm');
    
    this.searchForm    = $('form'); //全部form底下的搜尋
    this.searchBtn      = this.search.find('#searchButton');
    this.select         = $('#onlySelectBar');
    this.sort           = this.select.find('#orderChoose');
    this.type           = this.select.find('#prefectureChoose');
    this.realtyListDOM  = $('#buy_list_content');
    this.qty            = this.select.find('#orderQty');
    this.paginate       = $('#paginate a');
    this.paginateSelect = $('#paginate select');

    this.sortVal = this.search.find('#orderValue');
    this.typeVal = this.search.find('#prefectureValue');
    
    this.qtyVal  = this.search.find('#maxRowValue');
    this.pageVal = this.search.find('#pageVal');
    
    //this.buyAjaxStatus = true;
  }
  /*
  scrollLoad() {
    //捲軸載入資料
    $(window).on('scroll', () => {
      let footerHeight = $("#footerAds").outerHeight() + $('footer').outerHeight();
      let scrollBottom = $(document).height() - $(window).height() - footerHeight;
      if($(window).scrollTop() >= scrollBottom - 200) {
        if(this.buyAjaxStatus == true) {
          this.pageVal.val(parseInt(this.pageVal.val()) + 1); //頁碼+1
          $.ajax({
            url     : 'ajaxObjectContent.php',
            data    : this.searchForm.serialize(),
            type    : 'POST',
            dataType: 'html',
            beforeSend: () => {
              this.buyAjaxStatus = false; //執行時，不再進入ajax讀取用
              $("#pageScroll").show();
            },
            success: (msg) => {
              $("#pageScroll").hide();
              if(msg != ''){
                //成功執行並有值回來的狀況
                $('.objRealty>ul').append(msg);
                this.buyAjaxStatus = true;

                //引入外部模組
                let bodyCtrl = new BodyCtrl;
                let lazyLoad = new LazyLoad;
                let lightbox = new Lightbox;
                let track    = new Track;

                lazyLoad.imgLoad();  //圖片延遲載入
                track.toggleTrack(); //加入追蹤
                lightbox.map();      //Lightbox-Google Map
                lightbox.form();     //Lightbox-表單
              }else{
                console.log(msg)
              }
            }
          });
        }
      }
    });
  }
  */
  //搜尋使用get
  getSearch(dataFile) {
    let getData = () => {
      //--------------------------
      //把該名字的所有name值加總為陣列，並轉為字串輸出
      function GetCheckedValue(checkBoxName)  { 
        let returnVal = $("input[name='" + checkBoxName + "']:checked").map(function () {
        // let returnVal = $("input[name='" + checkBoxName + "']").is(":checked").prop('checked',true).map(function () {
          return $(this).val();
        }).get();
        //過濾重覆值
        // console.log( checkBoxName+"::"+returnVal); 
        var result = returnVal.filter(function(element, index, arr){
          return arr.indexOf(element) === index;
        });
        // console.log( returnVal ) ;
        return result.join(',');
      } //function GetCheckedValue(checkBoxName)  {
        
      //處理參數
      let keyName = ''; //暫存key值，判斷是否有重覆
      let getURL = this.searchForm.find("input").map(function () {
        // console.log("進入:"+$(this).attr('name'));
          if($(this).attr('type') === 'radio' || $(this).attr('type') === 'checkbox') { //radio、checkbox的陣列處理
            if($(this).is(':checked') == true && $(this).val() != '不限') { //判斷是否有選取
              // console.log("處理陣列:"+$(this).attr('name'));
              return $(this).attr('name')+'='+ GetCheckedValue( $(this).attr('name') );
            }
          } else {
            //非陣列處理
            //判斷空值
            if( $(this).val() != '' && $(this).length != 0 && $(this).attr('name') != 'nav' ) {
              return $(this).attr('name')+'='+encodeURIComponent($(this).val());
            }
          }
      }).get(); //傳回時字串，用逗號分隔

      //過濾重覆值
      var result = getURL.filter(function(element, index, arr){
        return arr.indexOf(element) === index;
      });
      // console.log(getURLString);
      let getURLString = Array.from(result).join('&'); //篩選完重覆，陣列轉字串 
      let formAction = this.searchForm.attr('action'); //抓傳值路徑(買屋、租屋、新成屋頁面)
      location.href='./' + formAction + '&q=' + encodeURIComponent(getURLString); //轉址
      //--------------------------
    }
    getData(); //執行
  }

  ajaxPost(dataFile) {
    let ajaxData = () => {
      
      /*
      $.ajax({
        url : dataFile,
        type: 'POST',
        data: this.searchForm.serialize(),
        //傳送前動作
        beforeSend: () => {
          //引入外部模組
          let bodyCtrl = new BodyCtrl;

          //讀取頁面
          (checkDevice.ios || checkDevice.android) ? bodyCtrl.ctrl('scrollHideF') : bodyCtrl.ctrl('scrollHide');
          this.preloader.removeClass('active');
          this.logo.addClass('active');

          //畫面移動到搜尋區塊
          $('html, body').animate({+
            scrollTop: $('.area').offset().top - this.header.outerHeight()
          }, 1000);
        },
        //錯誤
        error: (xhr) => {
          //alert('Ajax request 發生錯誤');
        },
        //執行
        success: (response) => {
          //產生物件DOM
          this.realtyListDOM.html(response);

          //引入外部模組
          let bodyCtrl = new BodyCtrl;
          let lazyLoad = new LazyLoad;
          let lightbox = new Lightbox;
          let track    = new Track;

          //讀取頁面(移除)
          setTimeout(() => {
            this.logo.removeClass('active');
            this.preloader.addClass('active');
            bodyCtrl.ctrl('scrollShow');  //控制瀏覽器捲軸
            bodyCtrl.ctrl('scrollShowF'); //控制瀏覽器捲軸
          }, 500);

          lazyLoad.imgLoad();  //圖片延遲載入
          track.toggleTrack(); //加入追蹤
          lightbox.map();      //Lightbox-Google Map
          lightbox.form();     //Lightbox-表單

          //選擇頁碼
          $('#paginate a').on('click', (e) => {
            const $this = $(e.currentTarget);
            $('#page').val($this.attr('data-info'));
            ajaxData();
          });
          $('#paginate select').on('change', (e) => {
            const $this = $(e.currentTarget);
            $('#page').val($this.find('option:selected').attr("data-info"));
            ajaxData();
          });
        }
      });
      */
      //更改網址(此部分直接做get版本)
      //----------------------------
      /*
      //把該名字的所有name值加總為陣列，並轉為字串輸出
      function GetCheckedValue(checkBoxName)  { 
        let returnVal = $("input[name='" + checkBoxName + "']:checked").map(function () {
          return $(this).val();
        }).get();
        //過濾重覆值
        var result = returnVal.filter(function(element, index, arr){
          return arr.indexOf(element) === index;
        });
        // console.log('進入GetCheckedValue處理::'+result);
        return result.join(',');
      } //function GetCheckedValue(checkBoxName)  {
      //處理參數
      let keyName = ''; //暫存key值，判斷是否有重覆
      let getURL = this.searchForm.find("input").map(function () {
        // if( $(this).attr('name') != undefined ) {
          if($(this).attr('type') === 'radio' || $(this).attr('type') === 'checkbox' ) { //radio、checkbox的陣列處理
            if($(this).is(':checked') == true && $(this).val() != '不限') { //判斷是否有選取
              return $(this).attr('name')+'='+ GetCheckedValue( $(this).attr('name') );
            }
          } else {
            //非陣列處理
            if( $(this).val() != '' && $(this).length != 0 && $(this).attr('name') != 'nav' ) {
              return $(this).attr('name')+'='+encodeURIComponent($(this).val());
            }
          }
      }).get(); //傳回時字串，用逗號分隔

      //過濾重覆值
      var result = getURL.filter(function(element, index, arr){
        return arr.indexOf(element) === index;
      });
      console.log('ajaxPost');
      let getURLString = Array.from(result).join('&'); //篩選完重覆，陣列轉字串
      let formAction = this.searchForm.attr('action'); //抓傳值路徑(買屋、租屋、新成屋頁面)
      location.href='./' + formAction + '&q=' + encodeURIComponent(getURLString); //轉址
      alert('123');
      // history.pushState('./' + formAction + '&' + getURLString);
      // history.pushState('./?abc' );
      // var stateObj = { foo: "buy" };
      // history.pushState(stateObj, "買屋內頁", "./?nav=buy&q="+encodeURIComponent(getURLString));
      */
     
      
      //決定版get方式
      //把該名字的所有name值加總為陣列，並轉為字串輸出
      function GetCheckedValue(checkBoxName)  { 
        let returnVal = $("input[name='" + checkBoxName + "']:checked").map(function () {
        // let returnVal = $("input[name='" + checkBoxName + "']").is(":checked").prop('checked',true).map(function () {
          return $(this).val();
        }).get();
        //過濾重覆值
        // console.log( checkBoxName+"::"+returnVal); 
        var result = returnVal.filter(function(element, index, arr){
          return arr.indexOf(element) === index;
        });
        // console.log( returnVal ) ;
        return result.join(',');
      } //function GetCheckedValue(checkBoxName)  {
        
      //處理參數
      let keyName = ''; //暫存key值，判斷是否有重覆
      let getURL = this.searchForm.find("input").map(function () {
        // console.log("進入:"+$(this).attr('name'));
          if($(this).attr('type') === 'radio' || $(this).attr('type') === 'checkbox') { //radio、checkbox的陣列處理
            if($(this).is(':checked') == true && $(this).val() != '不限') { //判斷是否有選取
              // console.log("處理陣列:"+$(this).attr('name'));
              return $(this).attr('name')+'='+ GetCheckedValue( $(this).attr('name') );
            }
          } else {
            //非陣列處理
            //判斷空值
            if( $(this).val() != '' && $(this).length != 0 && $(this).attr('name') != 'nav' ) {
              return $(this).attr('name')+'='+encodeURIComponent($(this).val());
            }
          }
      }).get(); //傳回時字串，用逗號分隔

      //過濾重覆值
      var result = getURL.filter(function(element, index, arr){
        return arr.indexOf(element) === index;
      });
      // console.log(getURLString);
      let getURLString = Array.from(result).join('&'); //篩選完重覆，陣列轉字串 
      let formAction = this.searchForm.attr('action'); //抓傳值路徑(買屋、租屋、新成屋頁面)
      location.href='./' + formAction + '&q=' + encodeURIComponent(getURLString); //轉址
      // alert('456');
      
     //--------------------------
    }
    ajaxData();
  }
  checkNavAjaxPost() {
    if(this.nav == 'buy' || this.nav == 'rent' || this.nav == 'all_object'){
      // console.log('ajax準備進入1');
      this.ajaxPost('ajax_buy_content.php');
      //this.scrollLoad();
    }else if(this.nav == 'new'){
      // console.log('ajax準備進入2');
      this.ajaxPost('ajax_newHouse_content.php');
      //this.scrollLoad();
    }
  }
  ajaxSearch() {
    //this.scrollLoad();
    //搜尋按鈕
    this.searchBtn.on('click', () => {
      this.lightbox.removeClass('active');
      this.search.removeClass('active');
      this.pageVal.val(1); //頁碼從1開始算
      this.checkNavAjaxPost();
    });
    this.searchForm.find('input[name=keyword_value]').bind('keypress', (e) => {
      if(e.keyCode == 13){
        e.preventDefault();
        if(this.nav == 'buy' || this.nav == 'rent' || this.nav == 'new' || this.nav == 'all_object'){
          this.lightbox.removeClass('active');
          this.search.removesClass('active');
          this.pageVal.val(1); //頁碼從1開始算
          this.checkNavAjaxPost();
        }
      }
    });

    //Select-預設排序
    this.sort.on('change', (e) => {
      const $this = $(e.currentTarget);
      this.pageVal.val(1); //頁碼從1開始算
      this.sortVal.val($this.val());
      this.checkNavAjaxPost();
    });

    //Select-物件類型
    this.type.on('change', (e) => {
      const $this = $(e.currentTarget);
      this.pageVal.val(1); //頁碼從1開始算
      this.typeVal.val($this.val());
      this.checkNavAjaxPost();
    });

    //Select-顯示筆數
    this.qty.on('change', (e) => {
      const $this = $(e.currentTarget);
      this.pageVal.val(1); //頁碼從1開始算
      this.qtyVal.val($this.val());
      this.checkNavAjaxPost();
    });

    //選擇頁碼
    this.paginate.on('click', (e) => {
      // console.log('123');
      const $this = $(e.currentTarget);
      this.pageVal.val($this.attr('data-info'));
      this.checkNavAjaxPost();
    });

    this.paginateSelect.on('change', (e) => {
      const $this = $(e.currentTarget);
      this.pageVal.val($this.find('option:selected').attr("data-info"));
      this.checkNavAjaxPost();
    });

  }
}



//輸出
export {ObjListAJAX};


// WEBPACK FOOTER //
// ./js_new/obj_list_ajax.js